module.exports = __webpack_public_path__ + "img/join-top-phone.7be77179.png";